
import { AclRoleReference } from '../enums';

export const AclRoleReferences = [
  { name: 'Workspace Admin', value: AclRoleReference.WorkspaceAdmin },
  { name: 'Project Manager', value: AclRoleReference.ProjectManager },
];
